<template>
    <div :class="ActiveState(item.Name)" @mouseenter="Hover(true)" @mouseleave="Hover(false)">
        <router-link class="align-c navigation-item" :to="item.URL" @click="Route()">{{ item.Name }}</router-link>
        <div class="sub-navigation" v-if="item.SubNavigation.length && (showSubNavigation || mobile)">
            <div class="btn sub-navigation-item" v-for="(subNavigationItem, s) in item.SubNavigation" :key="s" @click="$emit('sub-navigation-navigate', subNavigationItem)">
                <span>{{ subNavigationItem }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { profile } from "@/assets/JS/Config.js";

export default {
    name: "Navigation",
    props: {
        item: Object,
        mobile: Boolean
    },
    data: () => ({ showSubNavigation: false }),
    methods: {
        ActiveState: function(itemName) {
            itemName = `/${itemName.replace(/\s+/g, "-").toLowerCase()}`;
            const route = this.$route.fullPath;
            let urlMatch = route.toLowerCase().indexOf(itemName) !== -1;
            if (route === "/" || route.indexOf("/project/") !== -1) {
                urlMatch = itemName === "/projects";
            }
            return urlMatch ? "navigation-item-active" : "navigation-item-inactive";
        },
        Hover: function(over) { this.showSubNavigation = over; },
        Route: function() {
            if (this.item.Name === "Projects") {
                this.$emit("sub-navigation-navigate", profile.defaultLandingPage);
            }
        }
    },
    emits: [ "sub-navigation-navigate" ]
};
</script>